module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tagForm.tagKey.title":"Key","tagForm.tagValue.title":"Value","tagForm.newTag":"New Tag","tagForm.noTags":"You do not currently have any tags here"}}')
  delete Component.options._Ctor
}
